import { jsx as _jsx } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig'; // Adjust the path if necessary
import { CircularProgress, Alert, Box } from '@mui/material';
import SendInvitationForm from './Invitation/SendInvitationForm'; // Adjust the path if necessary
const OnboardingFetcher = () => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [assessments, setAssessments] = useState([]);
    const [checkpoints, setCheckpoints] = useState([]);
    useEffect(() => {
        let isMounted = true; // Track whether the component is mounted
        const fetchAssessments = async () => {
            try {
                const assessmentsRef = collection(db, 'assessments');
                const assessmentsSnapshot = await getDocs(assessmentsRef);
                const fetchedAssessments = assessmentsSnapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                if (isMounted) {
                    setAssessments(fetchedAssessments);
                }
            }
            catch (err) {
                if (isMounted) {
                    setError('Error fetching assessments');
                }
            }
        };
        const fetchCheckpoints = async () => {
            try {
                const checkpointsRef = collection(db, 'checkpoints');
                const checkpointsSnapshot = await getDocs(checkpointsRef);
                const fetchedCheckpoints = checkpointsSnapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data(),
                }));
                if (isMounted) {
                    setCheckpoints(fetchedCheckpoints);
                }
            }
            catch (err) {
                if (isMounted) {
                    setError('Error fetching checkpoints');
                }
            }
        };
        const fetchOnboarding = async () => {
            setLoading(true); // Start loading
            try {
                await Promise.all([fetchAssessments(), fetchCheckpoints()]);
            }
            catch (err) {
                if (isMounted) {
                    setError('Error fetching data');
                }
            }
            finally {
                if (isMounted) {
                    setLoading(false); // Set loading to false in any case
                }
            }
        };
        fetchOnboarding();
        return () => {
            isMounted = false; // Cleanup function to set isMounted to false
        };
    }, []);
    if (loading)
        return _jsx(CircularProgress, {});
    if (error)
        return _jsx(Alert, { severity: "error", children: error });
    return (_jsx(Box, { children: _jsx(SendInvitationForm, { assessments: assessments, checkpoints: checkpoints }) }));
};
export default OnboardingFetcher;
